import type { TransformedResult } from "~pages/Standings/types/transformedResult";
import { sortStringValues } from "~utils/utilities";

export const sortNestedTables = (a: TransformedResult<unknown>, b: TransformedResult<unknown>) => {
  const nameA = a.entity?.name;
  const nameB = b.entity?.name;
  if (a.entity?.id === "noKeyData") {
    return 1;
  }
  if (b.entity?.id === "noKeyData") {
    return -1;
  }
  if (nameA && nameB) {
    return sortStringValues(nameA, nameB);
  }
  return 0;
};
